// @ts-nocheck
import React from 'react';
// material
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// Project
import ButtonWithLoader from '../../../commons/containers/ButtonWithLoader';
import { useTranslation } from 'react-i18next';

function ProductForm(props) {
  const { isOpen, toggleForm, changeControls, controls, edit, submit, invalidControls, varieties } =
    props;

  const { t } = useTranslation();

  return (
    <Dialog fullWidth onClose={toggleForm} aria-labelledby="simple-dialog-title" open={isOpen}>
      <DialogTitle>{`${edit ? t('Edit') : t('Create')} ${t('Product')}`}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.name}
              onChange={changeControls}
              fullWidth
              id="name"
              label={t('Name')}
              error={invalidControls.name}
              helperText={invalidControls.name && t('Name is required')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.code}
              onChange={changeControls}
              fullWidth
              id="code"
              label={t('Code')}
              error={invalidControls.code}
              helperText={invalidControls.code && t('Code is required')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Autocomplete
              value={controls.varietyId ? varieties[controls.varietyId] : ''}
              id="autocomplete-varieties-products"
              options={Object.values(varieties).sort((a, b) => a.name - b.name)}
              getOptionLabel={(variety) => variety?.name || ''}
              renderInput={(params) => (
                <TextField
                  style={{ margin: 0 }}
                  {...params}
                  label={t('Variety')}
                  margin="normal"
                // error={invalidControls.fruitId}
                // helperText={invalidControls.fruitId && 'Debe ingresar una variedad'}
                />
              )}
              onChange={(event, newValue) => {
                const e = {
                  autocomplete: true,
                  input: 'varietyId',
                  value: newValue ? newValue.id : null,
                };
                changeControls(e);
              }}
            />
          </Grid>
          <Grid item sm={6} xs={12} className="mt-5">
            <FormControlLabel
              control={
                <Checkbox checked={controls.discard} onChange={changeControls} id="discard" />
              }
              label={t('Discard product')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleForm} color="primary">
          {t('Cancel')}
        </Button>
        <ButtonWithLoader onClick={submit} autoFocus buttonId="create-edit-product">
          {edit ? t('Edit') : t('Add')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default ProductForm;
